import { mapState } from 'vuex';

export default {
  data() {
    return {
      isVisible: false,
      lastStatusUpdate: 0,
    };
  },

  computed: {
    ...mapState('timemachine', {
      MODE_RCP_MSG_PLAY: (state) => state.MODE.RCP_MSG_PLAY,
      rowDuration: (state) => state.timeLayer.rowDuration,
      secondhandVisibilityTrigger: (state) => state.secondhandVisibilityTrigger,
    }),
  },

  watch: {
    gridEstablished() {
      if (this.gridEstablished) {
        this.$nextTick(() => {
          this.$_observe();
          this.$_makeItVisible();
        });
      }
    },

    secondhandVisibilityTrigger() {
      this.$nextTick(this.$_makeItVisible);
    },

    isVisible: '$_ensureItsVisibleDuringPlay',
    lastStatusUpdate: '$_ensureItsVisibleDuringPlay',
    MODE_RCP_MSG_PLAY: '$_ensureItsVisibleDuringPlay',
  },

  methods: {
    $_observe() {
      if (!window.IntersectionObserver) {
        return;
      }

      if (this.$options.observer) {
        this.$options.observer.unobserve(this.$options.observedElement);
      }

      const $root = this.$el.closest('.tm-timemachine');
      this.$options.observer = new IntersectionObserver(
        this.$_observerCallback,
        {
          root: $root,
          rootMargin: '0px',
          threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
        }
      );
      this.$options.observer.observe(this.$el);
      this.$options.observedElement = this.$el;
    },

    $_observerCallback(entries, observer) {
      entries.forEach((entry) => {
        this.$data.isVisible =
          entry.isIntersecting && entry.intersectionRatio > 0.75;
        this.$data.lastStatusUpdate = performance.now();
      });
    },

    $_ensureItsVisibleDuringPlay() {
      if (this.MODE_RCP_MSG_PLAY && !this.$data.isVisible) {
        this.$_makeItVisible();
      }
    },

    $_makeItVisible() {
      if (this.gridEstablished && this.$el && this.$el.scrollIntoView) {
        this.$el.scrollIntoView({
          behavior: 'auto',
          block: 'nearest',
          inline: 'nearest',
        });
      }
    },
  },
};
